// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'dinRoundOT', 'dinRoundOT Fallback', Objektiv, sans-serif"},"className":"__className_25af86","variable":"__variable_25af86"};